module.exports = __webpack_public_path__ + "img/ru_icon.37bd6f6.png";